import { animated } from 'react-spring';

import { styled } from '../../../hooks/theme';
import { getCssElevacao, getCssFont } from '../../../styles';
import { Tokens } from '../../../types';

interface ModalContentProps {
  size?: 'sm' | 'md' | 'lg';
}
export const ModalContent = styled(animated.div)<ModalContentProps>`
  padding: 1.25rem;
  width: ${props => {
    switch (props.size) {
      case 'sm':
        return '30%';
      case 'md':
        return '50%';
      case 'lg':
        return '80%';
      default:
        return '30%';
    }
  }};
  background: ${props => props.theme.colors.neutral.grey[0]};
  border: 4px solid ${props => props.theme.colors.neutral.grey[0]};
  border-radius: 8px;
  z-index: 2100;
  max-height: 80%;
  overflow-y: visible;
  overflow-x: hidden;
  ${props => getCssElevacao(props.theme.elevacao[4])}

  @media screen and (max-width: ${Tokens.breakpoints.tablet}px) {
    width: 80%;
  }
`;
ModalContent.defaultProps = {
  theme: Tokens.eixods,
};

export const ModalHeader = styled.div`
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  button {
    color: ${props => props.theme.colors.neutral.grey[70]};
  }
`;
ModalHeader.defaultProps = {
  theme: Tokens.eixods,
};
export const ModalHeaderText = styled.span`
  ${props => getCssFont(props.theme.font.desktop.heading.h4.bold)};
  color: ${props => props.theme.colors.neutral.grey[100]};
  white-space: break-spaces;
  word-break: break-word;
`;
ModalHeaderText.defaultProps = {
  theme: Tokens.eixods,
};

export const ModalTitle = styled.div`
  margin: 0;
`;

export const ModalBody = styled.div``;
